var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgDataTable = function SvgDataTable(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.92325 10.0384H4.8465V11.0768H6.92325V10.0384Z",
    fill: "#FF7F23"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0384 10.0384H7.96161V11.0768H10.0384V10.0384Z",
    fill: "#FF7F23"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92325 7.96162H4.8465V9H6.92325V7.96162Z",
    fill: "#FF7F23"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0384 12.1151H7.96161V13.1535H10.0384V12.1151Z",
    fill: "#FF7F23"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.92325 12.1151H4.8465V13.1535H6.92325V12.1151Z",
    fill: "#FF7F23"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1541 7.96162H11.0773V9H13.1541V7.96162Z",
    fill: "#FF7F23"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0384 7.96162H7.96161V9H10.0384V7.96162Z",
    fill: "#FF7F23"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1541 10.0384H11.0773V11.0768H13.1541V10.0384Z",
    fill: "#FF7F23"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1541 12.1151H11.0773V13.1535H13.1541V12.1151Z",
    fill: "#FF7F23"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7116 2.25H3.28838C3.01331 2.25056 2.74894 2.35969 2.55431 2.55431C2.35969 2.74894 2.25 3.01275 2.25 3.28838V14.7116C2.25056 14.9867 2.35969 15.2511 2.55431 15.4457C2.74894 15.6403 3.01275 15.75 3.28838 15.75H14.7116C14.9867 15.7494 15.2511 15.6403 15.4457 15.4457C15.6403 15.2511 15.75 14.9872 15.75 14.7116V3.28838C15.7494 3.01331 15.6403 2.74894 15.4457 2.55431C15.2511 2.35969 14.9872 2.25 14.7116 2.25ZM14.7116 3.28838V5.36513H3.28838V3.28838H14.7116ZM3.28838 14.7116V6.40406H14.7116V14.7116H3.28838Z",
    fill: "#FF7F23"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDataTable, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/data-table.36c6d3bd.svg";
export { ForwardRef as ReactComponent };